import { render, staticRenderFns } from "./SixthTab.vue?vue&type=template&id=9fb75612"
import script from "./SixthTab.vue?vue&type=script&lang=js"
export * from "./SixthTab.vue?vue&type=script&lang=js"
import style0 from "./SixthTab.vue?vue&type=style&index=0&id=9fb75612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports